const SortOrderElasticSearchEnum = {
  ascending: 'ASCENDING',
  descending: 'DESCENDING'
};

export { SortOrderElasticSearchEnum };
export default SortOrderElasticSearchEnum;
